// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__21CPI","error":"Textarea_error__3GdFq","readonly":"Textarea_readonly__2RLJo","disabled":"Textarea_disabled__1MIKb"};